import { ITag } from "./tags";
import { IImage } from "./images";
import { IOrganization } from "./organizations";
import { regionContent } from "../../../kursk/content/regionContent";

export type EntityType =
  'events'
  | 'places'
  | 'hotels'
  | 'restaurants'
  | 'overviews'
  | 'news'
  | 'articles'
  | 'routes'
  | 'streams'
  | 'ticketsbundles'
  | 'touristroutes'
  | 'halls'
  | 'regionvideos'
  | 'museums'
  | 'artefacts'
  | 'movies'
  | 'mapPoints'
  | 'excursions'
  | 'tours'
  | 'goods';

export const EntityTypeOnRussian = {
  'events': 'события',
  'places': 'места',
  'hotels': 'гостиницы',
  'restaurants': 'рестораны',
  'overviews': 'обзоры',
  'news': 'новости',
  'regionvideos': 'видеоролики о регионе',
  'routes': regionContent.entitiesNames.routes.plural,
  'streams': 'трансляции',
  'ticketsbundles': 'абонементы',
  'touristroutes': regionContent.entitiesNames.touristroutes.plural,
  'movies': 'фильмы',
  'halls': 'виртуальные концертные залы',
  'museums': 'виртуальные музеи',
  'artefacts': 'гиды дополненной реальности',
  'excursions': 'экскурсии',
  'tours': 'туры',
  'goods': 'астраханские сувениры',
}

export interface ILocale {
  _id: number;
  name: string;
  sysName: string;
  timezone: string;
  cover: IImage;
  image: IImage;
  description: string;
}

export interface ISeo {
  description?: string;
  title?: string;
}

export interface IAudio {
  name: string;
  realName: string;
  duration: number;
}

export interface IUserSocialsEsia {
  email: string;
  mobile: string;
  oid: number;
  user: {
    firstName: string;
    lastName: string;
    middleName: string;
  };
}

export interface IUser {
  _id: number;
  name: string;
  gender: string;
  registrationType: 'email' | 'phone';
  email?: string;
  avatar?: IImage;
  phone?: string;
  socials?: {
    esia?: IUserSocialsEsia;
  };
}

export interface IAddressUnit {
  name: string;
  fiasId: string;
  type: string;
}

export enum ContactType {
  'email' = 'email',
  'website' = 'website',
  'phone' = 'phone',
  'vk' = 'vk',
  'ok' = 'ok',
  'twitter' = 'twitter',
  'facebook' = 'facebook',
  'instagram' = 'instagram',
  'skype' = 'skype',
  'telegram' = 'telegram',
}

export interface EntityCommonFields {
  _id: number;
  allTags: ITag[];
  category: ITag;
  description: string;
  image: IImage;
  isPublished: boolean;
  locales: ILocale[];
  name: string;
  organization: IOrganization;
  seo: ISeo;
  sysName: string;
  tags: ITag[];
  user: IUser;
  createDate: number;
  updateDate: number;
  __name__keywords__: string[];
  source?: ISource;
}

export interface ITicketsInfo {
  allPrices: number[];
  available: number;
  maxPrice: number;
  minPrice: number;
  total: number;
  unlimited: boolean;
}

export interface IAddress {
  region: IAddressUnit;
  city: IAddressUnit;
  settlement?: IAddressUnit;
  street: IAddressUnit;
  house: IAddressUnit;
  comment: string;
}

export type IContact = {
  [key in ContactType]: string;
} & { type: ContactType }

export interface IMapPosition {
  type: 'Point';
  coordinates: number[];
}

export interface ISource {
  name: string;
  externalId: string;
  meta?: {
    locales?: number[];
    pushkin?: boolean;
  }
}

export interface IBuyButtonEventExtraProps {
  eventType?: 'schedules' | 'seances';
  schedulesId?: number;
  seancesId?: number;
}
